import React from 'react';
import { Box, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { sidebar, monoFont } from '../../theme';

// Item de navegación del sidebar navy — ver design_handoff_crediapp_redesign/README.md (Shell).
// Comparte el mismo estilo activo/inactivo entre NavLinks y los sub-menús
// (Administracion, Security, Configurations) para no duplicarlo 4 veces.
const NavItem = ({ to, icon, label, badge, end, sub, onClick }) => {
	return (
		<NavLink to={to} end={end} onClick={onClick} style={{ textDecoration: 'none' }}>
			{({ isActive }) => (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: sub ? '11px' : '13px',
						padding: sub ? '9px 12px 9px 16px' : '11px 12px',
						borderRadius: '11px',
						cursor: 'pointer',
						marginBottom: '2px',
						color: isActive ? sidebar.activeText : sidebar.itemColor,
						backgroundColor: isActive ? sidebar.activeBg : 'transparent',
						fontWeight: isActive ? 700 : 400,
						boxShadow: isActive ? `inset 3px 0 0 ${sidebar.activeBar}` : 'none',
						'&:hover': !isActive ? { backgroundColor: 'rgba(255,255,255,.06)', color: sidebar.userColor } : undefined
					}}
				>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontSize: sub ? 16 : 19,
							color: 'inherit',
							flexShrink: 0
						}}
					>
						{icon}
					</Box>
					<Typography sx={{ fontSize: sub ? 13 : 14.5, fontWeight: 'inherit', flex: 1, minWidth: 0 }}>{label}</Typography>
					{badge ? (
						<Box
							component="span"
							sx={{
								backgroundColor: '#e5484d',
								color: '#fff',
								fontSize: 10.5,
								fontWeight: 600,
								padding: '1px 7px',
								borderRadius: '20px',
								fontFamily: monoFont
							}}
						>
							{badge}
						</Box>
					) : null}
				</Box>
			)}
		</NavLink>
	);
};

export default NavItem;
